<div class="alert" [ngClass]="levelCSSClass">
  <div class="alert-icon fa" [ngClass]="icon"></div>
  <div class="alert-body" role="alert">
    <ng-content></ng-content>
  </div>
</div>
